const home = {
  hero: {
    title: '亲亲漫画网',
    subtitle: '免费下拉式看漫画，下拉式全集在线看',
    description: '好看的日漫韩漫下拉式漫画大全，免费追更下拉式在线推荐。流畅滑动，沉浸阅读，无需翻页，尽享漫画世界。',
    cta: '开始阅读',
    browseCategory: '浏览分类',
  },
  hotTitle: '热门推荐',
  newTitle: '最新上架',
  recommendedTitle: '编辑精选',
  viewAll: '查看全部',
  stats: {
    totalComics: '10000+',
    totalComicsLabel: '漫画资源',
    dailyUpdate: '200+',
    dailyUpdateLabel: '每日更新',
    activeUsers: '500万+',
    activeUsersLabel: '活跃读者',
  },
  features: {
    title: '为什么选择亲亲漫画网？',
    subtitle: '极致的下拉式漫画阅读体验，让追漫成为一种享受',
    items: [
      {
        icon: 'ri-book-read-line',
        title: '下拉式阅读',
        desc: '流畅的滚动阅读体验，告别翻页，一次加载整话内容，沉浸式畅读漫画。',
      },
      {
        icon: 'ri-shield-check-line',
        title: '完全免费',
        desc: '所有漫画资源永久免费，无需注册即可畅享海量日漫韩漫国漫。',
      },
      {
        icon: 'ri-flashlight-line',
        title: '极速更新',
        desc: '与官方同步更新，第一时间上线最新话，追更不等待。',
      },
      {
        icon: 'ri-smartphone-line',
        title: '全端适配',
        desc: '手机、平板、电脑完美适配，随时随地享受下拉式漫画阅读。',
      },
    ],
  },
  ctaBanner: {
    title: '准备好开始你的漫画之旅了吗？',
    subtitle: '加入500万+漫画爱好者，畅享免费下拉式漫画阅读',
    button: '立即开始阅读',
  },
};

export default home;